export const API_URL =
  process.env.REACT_APP_BACKEND_URL || "http://localhost:5000";

export const IS_PROD = Boolean(
  process.env.REACT_APP_AUTH0_CONFIG === "production"
);
